import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <Section background="olive-light" data-id="element-121">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-122">
        {/* Es para ti */}
        <div data-id="element-123">
          <h3 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center" data-id="element-124">
            <span className="bg-[#8B9D83] text-white p-1 rounded mr-3" data-id="element-125">
              <Check size={16} data-id="element-126" />
            </span>
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-127">
            <li className="flex items-start text-[#5A5A5A]" data-id="element-128">
              <Check className="h-5 w-5 text-[#8B9D83] mr-2 mt-0.5 flex-shrink-0" data-id="element-129" />
              <span data-id="element-130">Tienes 35+ y sientes cambios (perimenopausia)</span>
            </li>
            <li className="flex items-start text-[#5A5A5A]" data-id="element-131">
              <Check className="h-5 w-5 text-[#8B9D83] mr-2 mt-0.5 flex-shrink-0" data-id="element-132" />
              <span data-id="element-133">Quieres energía estable y menos antojos</span>
            </li>
            <li className="flex items-start text-[#5A5A5A]" data-id="element-134">
              <Check className="h-5 w-5 text-[#8B9D83] mr-2 mt-0.5 flex-shrink-0" data-id="element-135" />
              <span data-id="element-136">
                No quieres gimnasio, ni contar calorías, ni cocinar complicado
              </span>
            </li>
          </ul>
        </div>

        {/* No es para ti */}
        <div data-id="element-137">
          <h3 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center" data-id="element-138">
            <span className="bg-[#D4735E] text-white p-1 rounded mr-3" data-id="element-139">
              <X size={16} data-id="element-140" />
            </span>
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-141">
            <li className="flex items-start text-[#5A5A5A]" data-id="element-142">
              <X className="h-5 w-5 text-[#D4735E] mr-2 mt-0.5 flex-shrink-0" data-id="element-143" />
              <span data-id="element-144">Buscas resultados "en 7 días" o soluciones mágicas</span>
            </li>
            <li className="flex items-start text-[#5A5A5A]" data-id="element-145">
              <X className="h-5 w-5 text-[#D4735E] mr-2 mt-0.5 flex-shrink-0" data-id="element-146" />
              <span data-id="element-147">Quieres un plan de recetas gourmet o un reto extremo</span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}